module.exports = __webpack_public_path__ + "img/background.10165334.png";